import NodeDefinitionClass from '~/scripts/services/model/node-definition-class';
import NodeDefinitionKrepre from '~/scripts/services/model/node-definition-krepre';

export default class NodeDefinition {
	/**
	 * Instantiates a NodeDefinition object
	 *
	 * @param {'kndef' | 'kndefext'} [type]
	 * @param {any} [definition]
	 * @class
	 */
	constructor(type = 'kndef', definition = null) {
		// emulate a private property access
		this.getType = () => type;

		/** @type {string | undefined} */
		this.id = definition?.id;

		/** @type {any} */
		this.CLASS = new NodeDefinitionClass(definition?.CLASS);
		this.CREATE = definition?.CREATE ?? {};
		this.FILE = definition?.FILE ?? {};
		this.KDROIT = definition?.KDROIT ?? {};
		this.KFORM = definition?.KFORM ?? {};
		this.KNOTE = definition?.KNOTE ?? {};
		this.KPATH = definition?.KPATH ?? {};
		this.KREPRE = new NodeDefinitionKrepre(definition?.KREPRE);
		this.KWF = definition?.KWF ?? {};
		this.MF_CUSTOM = definition?.MF_CUSTOM ?? {};
		this.NAME_ONFLY = definition?.NAME_ONFLY ?? {};
		this.NAMING = definition?.NAMING ?? {};
		this.REPRE_TYPE = definition?.REPRE_TYPE ?? {
			ME: {
				USE: 'K_NODE;STRING',
			},
			OBJECT: {
				USE: 'K_NODE;STRING',
			},
		};
		this.SYNCK2K = definition?.SYNCK2K ?? null;
	}

	/**
	 * Add an item in kndef
	 *
	 * @param {'CLASS' | 'CREATE' | 'KDROIT' | 'KFORM' | 'KPATH' | 'KREPRE' | 'NAME_ONFLY' | 'NAMING'
	 * | 'MF_CUSTOM' | 'KWF'} group
	 * @param {'COMMON' | 'DICO' | 'MODE'} section Section (like COMMON, DICO, MODE...)
	 * @param {any} item Item to add
	 * @returns {null|number|string} Returns added item index if array, item key if object
	 */
	add(group, section, item) {
		let key;

		// If the key does not exist, create it so it's not undefined
		if (!this[group][section]) {
			this[group][section] = section === 'COMMON' ? [] : {};
		}

		if (Array.isArray(this[group][section])) {
			key = this[group][section].push({ ...item });
		}
		else if (typeof this[group][section] === 'object') {
			key = item.key || this.getNextKey(group, section);
			delete item.key;
			this[group][section][key] = { ...item };
		}
		else {
			console.error('unmanaged case');
		}
		return key;
	}

	fixId() {
		if (this.CLASS?.DICO) {
			for (const dicoId of Object.keys(this.CLASS.DICO)) {
				// check if key has not id
				if (!/^.+;\w{2}$/.test(dicoId)) {
					const newKey = `${this.id};${dicoId}`;

					// replace in CLASS.COMMON
					this.CLASS.COMMON.map((/** @type {any} */ common) => {
						if (common.dico_id === dicoId) {
							common.dico_id = newKey;
						}
						return common;
					});

					// replace in CLASS.DEFAULT_VALUE
					if (this.CLASS.DEFAULT_VALUE?.DICO && dicoId in this.CLASS.DEFAULT_VALUE.DICO) {
						Object.defineProperty(
							this.CLASS.DEFAULT_VALUE.DICO,
							newKey,
							// @ts-ignore
							Object.getOwnPropertyDescriptor(this.CLASS.DEFAULT_VALUE.DICO, dicoId),
						);
						delete this.CLASS.DEFAULT_VALUE.DICO[dicoId];
					}

					// replace in CLASS.RESTRICTED_VALUE
					if (this.CLASS.RESTRICTED_VALUE?.DICO && dicoId in this.CLASS.RESTRICTED_VALUE.DICO) {
						Object.defineProperty(
							this.CLASS.RESTRICTED_VALUE.DICO,
							newKey,
							// @ts-ignore
							Object.getOwnPropertyDescriptor(this.CLASS.RESTRICTED_VALUE.DICO, dicoId),
						);
						delete this.CLASS.RESTRICTED_VALUE.DICO[dicoId];
					}

					// replace IN CLASS.FILTERS
					if (this.CLASS.FILTERS && dicoId in this.CLASS.FILTERS) {
						Object.defineProperty(
							this.CLASS.FILTERS,
							newKey,
							// @ts-ignore
							Object.getOwnPropertyDescriptor(this.CLASS.FILTERS, dicoId),
						);
						delete this.CLASS.RESTRICTED_VALUE.DICO[dicoId];
					}

					// replace in CLASS.DICO
					Object.defineProperty(
						this.CLASS.DICO,
						newKey,
						// @ts-ignore
						Object.getOwnPropertyDescriptor(this.CLASS.DICO, dicoId),
					);
					delete this.CLASS.DICO[dicoId];
				}
			}
		}
	}

	/**
	 * Get converted CLASS.DICO to array
	 *
	 * @returns {any[]} dico in Map
	 */
	getDico() {
		return Object.entries(this.CLASS.DICO)
			.map(entry => ({ id: entry[0], ...entry[1] }));
	}

	/**
	 * Get the next key (for object items)
	 *
	 * @param {'CLASS' | 'CREATE' | 'KDROIT' | 'KFORM' | 'KPATH' | 'KREPRE' | 'NAME_ONFLY' | 'NAMING'
	 * | 'MF_CUSTOM' | 'KWF'} group
	 * @param {'COMMON' | 'DICO' | 'MODE'} section Section (like COMMON, DICO, MODE...)
	 * @returns {string} Returns item key
	 */
	getNextKey(group, section) {
		let returnValue = this.getType() === 'kndefext' ? 'a0a' : '00a';
		const string = Object.keys(this[group][section] || {})
			.filter(key => (this.id && key.split(';')[0] === this.id) || !this.id)
			.map(key => key.split(';')[1])
			.sort()
			.pop();

		if (string) {
			const nextLetter = (/** @type {number} */ l) => (l >= 97 && l < 122 ? String.fromCodePoint(l + 1) : 'a');
			let same = true;
			let index = string.length;

			while (index--) {
				if (string[index] !== 'z') {
					same = false;
				}
			}

			if (same) {
				let txt = '';
				index = string.length;
				while (index--) {
					txt += 'a';
				}
				returnValue = `${txt}a`;
			}
			else {
				let p = ''; let
					q = '';
				if (string.length > 1) {
					p = string.slice(0, Math.max(0, string.length - 1));
					q = String.fromCodePoint(p.slice(-1).codePointAt(0) || 0);
				}
				const l = string.slice(-1).codePointAt(0) || 0;
				const z = nextLetter(l);
				returnValue = z === 'a' ? p.slice(0, -1) + nextLetter(q.slice(-1).codePointAt(0) || 0) + z : p + z;
			}
		}

		return this.id ? `${this.id};${returnValue}` : returnValue;
	}

	/**
	 * Remove an item from kndef
	 *
	 * @param {'CLASS' | 'CREATE' | 'KDROIT' | 'KFORM' | 'KPATH' | 'KREPRE' | 'NAME_ONFLY' | 'NAMING'
	 * | 'MF_CUSTOM' | 'KWF'} group
	 * @param {'COMMON' | 'DICO' | 'MODE'} section Section (like COMMON, DICO, MODE...)
	 * @param {string|number} key Item index
	 */
	remove(group, section, key) {
		if (Array.isArray(this[group][section])) {
			this[group][section].splice(key, 1);
		}
		else if (this[group][section] && typeof this[group][section] === 'object' && key in this[group][section]) {
			delete this[group][section][key];
		}
	}

	/**
	 * Updates an item in kndef
	 *
	 * @param {'CLASS' | 'CREATE' | 'KDROIT' | 'KFORM' | 'KPATH' | 'KREPRE' | 'NAME_ONFLY' | 'NAMING'
	 * | 'MF_CUSTOM' | 'KWF'} group
	 * @param {'COMMON' | 'DICO' | 'MODE'} section Section (like COMMON, DICO, MODE...)
	 * @param {string|number} key Item key
	 * @param {any} item Item object
	 */
	update(group, section, key, item) {
		this[group][section][key] = item;
	}
}
